import React, { useState, useRef, useEffect } from 'react'
import "ag-grid-enterprise";
import "styles/ag-grid-header-style.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import axios from "@fuse/utils/axios";
import useRouter from "@fuse/hooks/useRouter";
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';
import { useDispatch, useSelector } from 'react-redux';
import { isArray } from 'lodash';
import { setrowGroupModel } from '../store/filterParamsReducer';


const action_to_color = {
    "CREATED": "green",
    "UPDATED": "orange",
    "ARCHIVED": "red",
    "RESTORED": "blue",
    'DELETED': "red"
}

function ActivityAgGridListing({ module, displayTableName = '' }) {
    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
    const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
    const [groupByArr, setGroupByArr] = useState([])
    const groupByModule = ['asset', 'Contract', 'service_request', 'subscription', 'Manufacture', 'Model',
        'Accessory', 'service_provider', 'subscription_provider', 'user', 'shipping', 'asset activity', 'asset_category',
        'custom_attributes', 'asset_status', 'accessory_category', 'payment_term', 'contract_tag', 'Contract Types',
        'service_level_agreement', 'location_type', 'department'
    ]
    const gridRef = useRef();
    const router = useRouter();
    const tableName = 'ASSETACTIVITY';
    const customFilterData = useSelector((state) => state.assetsApp.filterParamsReducer.custom_filter_data);
    const [redirectedWith, setRedirectedWith] = useState(null);
    const [isGridReady, setIsGridReady] = useState(0)
    const dispatch = useDispatch();

    const headers = [
        'action_id',
        'serial_number',
        'action_date_and_time',
        'action',
        'field_name',
        'previous_value',
        'current_value',
        'name',
        'user_role',
        'description'
    ]

    function cellRendererFrameworkFramework(params) {
        if (params.colDef.field === "action") {
            return (
                <span style={{
                    color: action_to_color[params.value],
                    fontWeight: 'bold'
                }}>{params.value}</span>
            )
        }
        if (params.colDef.field === "description" || params.colDef.field === 'previous_value' || params.colDef.field === 'current_value') {
            if (module === 'asset') {
                let desc = ''
                if (typeof params.value !== 'object' || !params.value) {
                    const date = params?.value?.split('{')[1]?.slice(0, -1)
                    if (date) {
                        const dateFormat = Intl.DateTimeFormat('en-US', {
                            month: 'numeric',
                            day: 'numeric',
                            year: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: true
                        }).format(new Date(date));

                        desc = `${params.value.split('{')[0]} ${dateFormat}`
                    } else {
                        desc = params.value
                    }
                    return (
                        <abbr style={{ textDecoration: 'none', wordBreak: 'break-word' }} title={desc}>{desc}</abbr>
                    )
                }
                desc = (params.value?.word && params.value?.number) ? `\u202A${params.value?.word} ` + `\u202C${params.value?.number}` : 'N/A'

                return (
                    <abbr style={{ textDecoration: 'none', wordBreak: 'break-word' }} title={desc}>{desc}</abbr>
                )

            }
            return (
                <abbr style={{ textDecoration: 'none', wordBreak: 'break-word' }} title={params.value}>{params.value}</abbr>
            )

        }
        return <>{params.value}</>

    }

    const generateHeaderLabel = (header) => {
        if (header === 'action_date_and_time') return 'Action date and time'
        return header
            .split("_")
            .map((word) => {
                return word.charAt(0).toUpperCase() + word.substring(1);
            })
            .join(" ");
    };

    const frameworkComponents = {
        customFilter: CustomFilter,
    };

    function onColumnRowGroupChanged(event) {
        if (event.columns.length === 0) {
            setGroupByArr([])
        } else {
            setGroupByArr(event.columns)
        }
        if (router.query.report_name === undefined) {
            const rows = event.api.getColumnState();
            const first_row = rows[1];
            if (first_row.colId !== "ag-Grid-AutoColumn") {
                dispatch(setrowGroupModel(rows));
                saveView(rows);
            } else {
                dispatch(setrowGroupModel(rows));
            }
        }
    }


    function onFilterChanged(event) {
        const totalRows = event.api.getDisplayedRowCount();
        if (totalRows === 0) {
            event.api.showNoRowsOverlay();
        } else {
            event.api.hideOverlay();
        }
    }

    async function onFetchAsset(params) {
        const url = '/assets/get-all-activities';
        const { startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode } = params.request;
        axios.post(url, {
            dataSourceParams: {
                startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode
            }
        }).then((res) => {
            	const rows = formatData(res.data.data.rows);
                const { lastRow } = res.data.data;
                (params.success || params.successCallback)?.({
                    rowData: rows,
                    rowCount: lastRow ?? rows.length,
                });
            if(rows.length === 0) gridRef.current.api.showNoRowsOverlay();
        }).catch((err) => {
            console.log('error', err)
            (params.fail || params.failCallback)?.();
        })
    }

    function formatData(data) {
        return data.map((item) => {
            return {
                id: item.asset_logs_id,
                action_id: item.action_id,
                serial_number: item?.serial_number ?? 'N/A',
                action_date_and_time: getLocalTimeFromUTC(item.created_at),
                name: item.user_name,
                action: item.action_name,
                description: item.comment,
                previous_value: item.previous_data,
                current_value: item.current_data,
                user_role: item.user_role_name,
                field_name: item.action_field_name
            }
        })
    }

    /** This object represents the data source for the grid.
*It defines a `getRows` function that is invoked by the grid to fetch rows from the server.
*/
    const datasource = {
        getRows(params) {
            // Call the function to fetch asset data from the server.
            onFetchAsset(params)
        }
    };

    useEffect(() => {
        setRedirectedWith(customFilterData)
        if (customFilterData === 'all') {
            saveView('N/A')
        }
        // dispatch(setCustomFilterData(null))
    }, [customFilterData])

    const onGridReady = (params) => {
        gridRef.current = params
        setIsGridReady(isGridReady + 1)
        params.api.sizeColumnsToFit()
        // setGridApi(params)
        if (router.query.report_name === undefined) {
            loadInitialState(params)
        }
    };

    function saveView(rows, filter, filterModelArr = null) {
        if (isArray(rows) && !rows.length) return
        let payload = {}
        if (rows === 'N/A') {
            payload = {
                filter: customFilterData === 'all' ? '{}' : JSON.stringify(filterModelArr ?? filter),
                table_name: tableName
            }
        } else {
            payload = {
                order: JSON.stringify(rows),
                table_name: tableName
            }
        }

        axios.post('/user-view/save-view-order', payload)
            .then(() => {
                console.log('view updated')
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onColumnMoved = (params) => {
        const rows = params.api.getColumnState();
        if (router.query.report_name === undefined) {
            saveView(rows);
            dispatch(setrowGroupModel(rows))
        }
    }

    const onColumnPinned = (params) => {
        if (router.query.report_name === undefined) {
            const rows = params.api.getColumnState();
            saveView(rows);
            dispatch(setrowGroupModel(rows))
        }
    };

    function onSortChanged(params) {
        const rows = params.api.getColumnState();
        if (router.query.report_name === undefined) {
            dispatch(setrowGroupModel(rows))
            saveView(rows);
        }
    }

    function loadInitialState(params) {
        axios
            .get(`/user-view/show-view-order?table_name=${tableName}`)
            .then((results) => {
                const { data } = results.data;
                if (data !== null) {
                    const order = JSON.parse(data.order);
                    const filter = JSON.parse(data?.filter);
                    gridRef.current = { ...gridRef.current, filterModelArr: filter }
                    params?.api.applyColumnState({ state: order });
                    params.api.setFilterModel(filter)
                }
                // gridRef.current.api.setFilterModel(filterModel);
                // params?.api.setGridOption('serverSideDatasource', datasource);
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                params?.api.setGridOption('serverSideDatasource', datasource);
            })
    }

    return (
        <>
            {groupByModule.includes(module) && <AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
                groupByArrFromList={groupByArr}
                key={isGridReady}
                tableName="activity_logs" activityModuleName={module} displayTableName={displayTableName} forActivity
            />
            }
            <div
                className="ag-theme-alpine"
                style={{
                    width: "100%",
                    height: windowHeight + 90,
                    fontSize: "12px",
                    display: ''
                }}
            >
                <AgGridReact
                    ref={gridRef}
                    theme="legacy"
                    onGridReady={onGridReady}
                    animateRows
                    // rowData = {props.endUsersAccounts}
                    rowHeight={30}
                    headerHeight={44}
                    rowModelType='serverSide'
                    serverSideStoreType="partial"
                    defaultColDef={{
                        enableRowGroup: true,
                        sortable: true,
                        resizable: true
                    }}
                    defaultExcelExportParams={{
                        sheetName: 'Dalos-Source'
                    }}
                    pagination
                    overlayNoRowsTemplate="<span>No Result Found</span>"

                    // Row Grouping conditions
                    showOpenedGroup
                    suppressDragLeaveHidesColumns
                    suppressMakeColumnVisibleAfterUnGroup
                    rowGroupPanelShow={rowGroupPanelShow}
                    groupHeaderHeight={1}
                    components={frameworkComponents}
                    floatingFiltersHeight={40}
                    onColumnMoved={onColumnMoved}
                    onColumnPinned={onColumnPinned}
                    // onColumnVisible={onColumnVisible}
                    onSortChanged={(event) => onSortChanged(event)}
                    // onSortChanged={onSortChanged}
                    // get filter model
                    onFilterChanged={(event) => onFilterChanged(event)}

                    // on column group changed
                    onColumnRowGroupChanged={(event) => onColumnRowGroupChanged(event)}
                    columnDefs= {headers.map((header) => {
                        if (header === 'action_date_and_time') {
                            return {
                                field: header,
                                key: header,
                                suppressSizeToFit: true,
                                // suppressRowClickSelection={true}
                                headerName: generateHeaderLabel(header),
                                filter: "agTextColumnFilter",
                                minWidth: 250,
                                sortable: true,
                                cellRenderer: (event) => cellRendererFrameworkFramework(event),
                                // comparator={customSort}
                                headerComponent: (props) => (CustomFilter(props, header, gridRef))
                            }
                        } if (header === 'description') {
                            return {
                                field: header,
                                key: header,
                                suppressSizeToFit: true,
                                // suppressRowClickSelection={true}
                                headerName: generateHeaderLabel(header),
                                filter: "agTextColumnFilter",
                                wrapText: true,
                                autoHeight: true,
                                sortable: true,
                                cellRenderer: (event) => cellRendererFrameworkFramework(event),
                                // comparator={customSort}
                                headerComponent: (props) => (CustomFilter(props, header, gridRef))
                            }
                        }
                        return {
                            field: header,
                            key: header,
                            suppressSizeToFit: true,
                            suppressRowClickSelection: true,
                            headerName: generateHeaderLabel(header),
                            filter: "agTextColumnFilter",
                            minWidth: (header === 'service_provider_name' || header === 'service_level_agreement_name') ? 300 : 200,
                            sortable: true,
                            wrapText: true,
                            // autoHeight = {header.field === 'description'}
                            cellRenderer: (event) => cellRendererFrameworkFramework(event),

                            headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                        }
                    })}
                 />
            </div>
        </>
    )
}

export default ActivityAgGridListing;